module.exports = __webpack_public_path__ + "static/media/Chinmayi_Balusu.b875ebfb.jpg";